<div class="min-h-screen bg-background text-foreground transition-colors">
    <div kendoDialogContainer></div>
    <router-outlet></router-outlet>
</div>
